import React from 'react';
import '../styles/About.css';

function About({ onBack }) {
  return (
    <div className="about-container">
      <div className="about-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>About</h2>
      </div>

      <div className="about-content">
        <div className="about-logo-section">
          <div className="about-logo">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              <line x1="9" y1="10" x2="15" y2="10"/>
              <line x1="9" y1="14" x2="13" y2="14"/>
            </svg>
          </div>
          <h1 className="app-name">UcmaApp </h1>
          <p className="app-version">Version 1.0.0</p>
          <p className="app-tagline">Stay Connected, Anywhere, Anytime</p>
        </div>

        <div className="about-section">
          <h3>Our Mission</h3>
          <p>
            Ucmaapp is designed to bring people together through seamless, secure, and feature-rich 
            messaging. Our mission is to provide a communication platform that respects your privacy 
            while offering the best user experience possible.
          </p>
        </div>

        <div className="about-section">
          <h3>What We Offer</h3>
          <div className="features-grid">
            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              </svg>
              <h4>Instant Messaging</h4>
              <p>Send text messages, photos, videos, and documents instantly</p>
            </div>

            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                <path d="M16 3.13a4 4 0 010 7.75"/>
              </svg>
              <h4>Group Chats</h4>
              <p>Create groups with up to 256 members and collaborate effortlessly</p>
            </div>

            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
              </svg>
              <h4>Voice & Video Calls</h4>
              <p>High-quality voice and video calling for personal conversations</p>
            </div>

            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <h4>Privacy & Security</h4>
              <p>End-to-end encryption and robust privacy controls</p>
            </div>

            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
              <h4>Status Updates</h4>
              <p>Share photos and videos that disappear after 24 hours</p>
            </div>

            <div className="feature-item">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <h4>Location Sharing</h4>
              <p>Share your real-time location with friends and family</p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h3>Our Values</h3>
          <div className="values-list">
            <div className="value-item">
              <div className="value-icon">🔒</div>
              <div>
                <h4>Privacy First</h4>
                <p>Your conversations are yours alone. We don't read or share your messages.</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">⚡</div>
              <div>
                <h4>Fast & Reliable</h4>
                <p>Messages are delivered instantly with minimal data usage.</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">🌍</div>
              <div>
                <h4>Global Connection</h4>
                <p>Connect with anyone, anywhere in the world, instantly.</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">💡</div>
              <div>
                <h4>Innovation</h4>
                <p>We constantly improve and add new features based on user feedback.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h3>Technology Stack</h3>
          <p>
            Ucmaapp is built using modern web technologies to ensure the best performance, security, 
            and user experience:
          </p>
          <div className="tech-stack">
            <span className="tech-badge">React</span>
            <span className="tech-badge">Node.js</span>
            <span className="tech-badge">Socket.IO</span>
            <span className="tech-badge">MongoDB</span>
            <span className="tech-badge">WebRTC</span>
            <span className="tech-badge">Express</span>
            <span className="tech-badge">PWA</span>
          </div>
        </div>

        <div className="about-section">
          <h3>Our Team</h3>
          <p>
            Ucmaapp is developed and maintained by a passionate team of engineers, designers, and 
            product managers dedicated to creating the best messaging experience. We believe in open 
            communication, continuous improvement, and putting our users first.
          </p>
        </div>

        <div className="about-section">
          <h3>Get Involved</h3>
          <p>
            We're always looking to improve Ucmaapp based on your feedback. Here's how you can 
            contribute:
          </p>
          <ul>
            <li>Share your feedback and suggestions through the app</li>
            <li>Report bugs or technical issues to help us improve</li>
            <li>Spread the word and invite your friends to Ucmaapp</li>
            <li>Follow us on social media for updates and announcements</li>
          </ul>
        </div>

        {/* <div className="about-section">
          <h3>Stay Connected</h3>
          <div className="social-links">
            <a href="#" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="#" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a>
            <a href="#" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a href="#" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div> */}

        {/* <div className="about-section legal-links">
          <a href="#" className="legal-link">Privacy Policy</a>
          <span className="separator">•</span>
          <a href="#" className="legal-link">Terms of Service</a>
          <span className="separator">•</span>
          <a href="#" className="legal-link">Licenses</a>
        </div> */}

        <div className="about-footer">
          <p>© 2025 Ucmaapp Inc. All rights reserved.</p>
          <p className="footer-note">
            Made with ❤️ for connecting people worldwide
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;

